import WhiteBoard from "src/components/WhiteBoard";
import { CgToday } from "react-icons/cg";
import Skeleton from "react-loading-skeleton";
import { useContext, useEffect, useState } from "react";
import shopContext from "src/context/shopContext";
import { getData } from "src/actions/getData";
import { LuCircleDashed } from "react-icons/lu";
import { get } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";

export default function WarehouseIssues() {
    const [unavailableStocks, setUnavailableStocks] = useState()
    const [overStockQuantity, setOverStockQuantity] = useState()
    const [undefinedStock, setUndefinedStock] = useState()


    const { inconsistenceItems, setInconsistenceItems } = useContext(shopContext)

    // useEffect(() => {
    //     if (!inconsistenceItems) {
    //         getData(setInconsistenceItems, "/sepidar/inconsistenceItems");
    //     }
    // }, [])

    // useEffect(() => {
    //     if (inconsistenceItems) {
    //         setUnavailableStocks(inconsistenceItems.filter(item => {
    //             if (parseInt(item.sepQuantity) < parseInt(item.reservedQuantity)) {
    //                 return item
    //             }
    //         }))
    //     }
    // }, [inconsistenceItems])

    // useEffect(() => {
    //     if (inconsistenceItems) {
    //         setOverStockQuantity(inconsistenceItems.filter(item => {
    //             if (parseInt(item.stock_quantity) > parseInt(item.sepQuantity) - (parseInt(item.reservedQuantity) + parseInt(item.missedQuantity))) {
    //                 return item
    //             }
    //         }))
    //     }
    // }, [inconsistenceItems])

    // useEffect(() => {
    //     if (inconsistenceItems) {
    //         setUndefinedStock(inconsistenceItems.filter(item => {
    //             if (item.sku && !item.code && item.stock_quantity) {
    //                 return item
    //             }
    //         }))
    //     }
    // }, [inconsistenceItems])

    return (
        <WhiteBoard className="!rounded-2xl my-2">
            <div className="flex items-center gap-4">
                <div className="bg-red-50 text-red-500 rounded-full p-4">
                    <CgToday size={30} />
                </div>
                <div className="flex flex-col w-full gap-1">
                    <span className="font-bold">اقدامات جاری (موجودی)</span>
                    {
                        inconsistenceItems ? (
                            <>
                                {unavailableStocks?.length > 0 && (
                                    <div className="flex items-center gap-1">
                                        <LuCircleDashed size={14} />
                                        <span className="text-sm">
                                            از کالا(ها) {unavailableStocks.map(item => item.sku).join(" / ")} بیشتر از موجودی انبار فروختیم، لطفا موجودی انبار و سپیدارشون رو چک کن ...
                                        </span>
                                    </div>
                                )}
                                {overStockQuantity?.length > 0 && (
                                    <div className="flex items-center gap-1">
                                        <LuCircleDashed size={14} />
                                        <span className="text-sm">
                                            از کالا(ها) {overStockQuantity.map(item => item.sku).join(" / ")} بیشتر از موجودی انبار در سایت موجود کردیم، لطفا موجودی سایتشون رو چک کن ...
                                        </span>
                                        <span className="text-blue-500 underline cursor-pointer text-sm" onClick={
                                            async () => {
                                                notify("فرآیند بروزرسانی موجودی‌ها شروع شد، لطفا چند دقیقه صبر کنید", "success")
                                                let result = await get("/sepidar/syncStocks?token=4LAcCKWxKRFGSP3pXDy8byog7a3YU8bqQJv")
                                                notify(result?.message, result.success ? "success" : "error")
                                            }
                                        }>(بروزرسانی موجودی‌ها)</span>
                                    </div>
                                )}
                                {undefinedStock?.length > 0 && (
                                    <div className="flex items-center gap-1">
                                        <LuCircleDashed size={14} />
                                        <span className="text-sm">
                                            کالا(ها) {undefinedStock.map(item => item.sku).join(" / ")} رو در سایت موجود کردیم، اما هنوز داخل سپیدار تعریف نشدن (یا رسید ورود نخوردن) ...
                                        </span>
                                    </div>
                                )}
                                {
                                    unavailableStocks?.length == 0 && overStockQuantity?.length == 0 && undefinedStock?.length == 0
                                    &&
                                    (
                                        <div className="flex items-center gap-1">
                                            <LuCircleDashed size={14} />
                                            <span className="text-sm">
                                                خوبه هیچ کاری واسه انجام دادن نیست!
                                            </span>
                                        </div>
                                    )
                                }
                            </>
                        ) : (
                            <Skeleton height={30} />
                        )
                    }
                </div>
            </div>
        </WhiteBoard>
    )
}
